import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseLoginComponent } from './login.component';
import { CommonModule } from '@angular/common';

const routes = [
    {
        path     : 'pages/auth/login',
        component: FuseLoginComponent
    }
];

@NgModule({
    declarations: [
        FuseLoginComponent
    ],
    imports     : [
        SharedModule,
        CommonModule,
        RouterModule.forChild(routes)
    ]
})

export class LoginModule
{

}
